var _desc, _style, _path, _path2, _path3, _ellipse, _desc2, _style2, _ellipse2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
const SvgIconOrb1 = /*#__PURE__*/React.forwardRef((_ref, ref) => {
  let {
    className,
    height = 122,
    titleId,
    title,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 122 122",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    role: "img",
    "aria-labelledby": titleId,
    className: className,
    height: height,
    ref: ref
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId || "orb1-title"
  }, "Railway Deployment Orb") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId || "orb1-title"
  }, title) : null, _desc || (_desc = /*#__PURE__*/React.createElement("desc", {
    id: "orb1-desc"
  }, "An animated orbital design representing Railway deployment options. Features an orange ellipse that moves in a triangular bouncing pattern, symbolizing deployment connectivity and movement.")), _style || (_style = /*#__PURE__*/React.createElement("style", null, "\n    @media (prefers-reduced-motion: reduce) {\n      * {\n        animation-duration: 0.01ms !important;\n        animation-iteration-count: 1 !important;\n        transition-duration: 0.01ms !important;\n      }\n    }\n    \n    @media (prefers-contrast: high) {\n      ellipse[fill=\"rgb(var(--color-brand-accent))\"] {\n        fill: #FF0000 !important;\n        stroke: #000000 !important;\n        stroke-width: 1px !important;\n      }\n    }\n  ")), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M105.767 60.8605C105.767 93.9206 85.7233 120.721 60.9986 120.721C36.2738 120.721 16.2305 93.9206 16.2305 60.8605C16.2305 27.8005 36.2738 1 60.9986 1C85.7233 1 105.767 27.8005 105.767 60.8605Z",
    stroke: "currentColor"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M73.8397 61.1375C73.8397 94.1976 68.0896 120.998 60.9966 120.998C53.9035 120.998 48.1534 94.1976 48.1534 61.1375C48.1534 28.0775 53.9035 1.27699 60.9966 1.27699C68.0896 1.27699 73.8397 28.0775 73.8397 61.1375Z",
    stroke: "currentColor"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M61 120.721C94.1371 120.721 121 93.9206 121 60.8605C121 27.8005 94.1371 1 61 1M61 120.721C27.8629 120.721 1 93.9206 1 60.8605C1 27.8005 27.8629 1 61 1M61 120.721C76.2978 120.721 88.6995 93.9206 88.6995 60.8605C88.6995 27.8005 76.2978 1 61 1M61 120.721C45.7022 120.721 33.3011 93.9206 33.3011 60.8605C33.3011 27.8005 45.7022 1 61 1M116.507 60.8613C116.507 93.9214 91.6551 120.722 60.9987 120.722C30.3423 120.722 5.49041 93.9214 5.49041 60.8613C5.49041 27.8013 30.3423 1.00079 60.9987 1.00079C91.6551 1.00079 116.507 27.8013 116.507 60.8613Z",
    stroke: "currentColor",
    strokeDasharray: "2 2"
  })), _ellipse || (_ellipse = /*#__PURE__*/React.createElement("ellipse", {
    cx: 61,
    cy: 4,
    rx: 3.86401,
    ry: 3.85501,
    fill: "rgb(var(--color-brand-accent))"
  }, /*#__PURE__*/React.createElement("animateMotion", {
    dur: "8s",
    repeatCount: "indefinite",
    path: "M 0 0 L 12.8397 59.998 L -12.8397 59.998 L 0 0"
  }))));
});
export const Icon = /*#__PURE__*/React.forwardRef((_ref2, ref) => {
  let {
    className: propClassName = "",
    fill = "none",
    stroke = "currentColor",
    weight = "normal",
    height = 122,
    titleId,
    title,
    ...props
  } = _ref2;
  const className = "vector-effect-non-scaling-stroke " + propClassName;
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 122 122",
    fill: fill,
    xmlns: "http://www.w3.org/2000/svg",
    role: "img",
    "aria-labelledby": titleId,
    className: className,
    height: height,
    ref: ref
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId || "orb1-title"
  }, "Railway Deployment Orb") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId || "orb1-title"
  }, title) : null, _desc2 || (_desc2 = /*#__PURE__*/React.createElement("desc", {
    id: "orb1-desc"
  }, "An animated orbital design representing Railway deployment options. Features an orange ellipse that moves in a triangular bouncing pattern, symbolizing deployment connectivity and movement.")), _style2 || (_style2 = /*#__PURE__*/React.createElement("style", null, "\n    @media (prefers-reduced-motion: reduce) {\n      * {\n        animation-duration: 0.01ms !important;\n        animation-iteration-count: 1 !important;\n        transition-duration: 0.01ms !important;\n      }\n    }\n    \n    @media (prefers-contrast: high) {\n      ellipse[fill=\"rgb(var(--color-brand-accent))\"] {\n        fill: #FF0000 !important;\n        stroke: #000000 !important;\n        stroke-width: 1px !important;\n      }\n    }\n  ")), /*#__PURE__*/React.createElement("path", {
    d: "M105.767 60.8605C105.767 93.9206 85.7233 120.721 60.9986 120.721C36.2738 120.721 16.2305 93.9206 16.2305 60.8605C16.2305 27.8005 36.2738 1 60.9986 1C85.7233 1 105.767 27.8005 105.767 60.8605Z",
    stroke: stroke
  }), /*#__PURE__*/React.createElement("path", {
    d: "M73.8397 61.1375C73.8397 94.1976 68.0896 120.998 60.9966 120.998C53.9035 120.998 48.1534 94.1976 48.1534 61.1375C48.1534 28.0775 53.9035 1.27699 60.9966 1.27699C68.0896 1.27699 73.8397 28.0775 73.8397 61.1375Z",
    stroke: stroke
  }), /*#__PURE__*/React.createElement("path", {
    d: "M61 120.721C94.1371 120.721 121 93.9206 121 60.8605C121 27.8005 94.1371 1 61 1M61 120.721C27.8629 120.721 1 93.9206 1 60.8605C1 27.8005 27.8629 1 61 1M61 120.721C76.2978 120.721 88.6995 93.9206 88.6995 60.8605C88.6995 27.8005 76.2978 1 61 1M61 120.721C45.7022 120.721 33.3011 93.9206 33.3011 60.8605C33.3011 27.8005 45.7022 1 61 1M116.507 60.8613C116.507 93.9214 91.6551 120.722 60.9987 120.722C30.3423 120.722 5.49041 93.9214 5.49041 60.8613C5.49041 27.8013 30.3423 1.00079 60.9987 1.00079C91.6551 1.00079 116.507 27.8013 116.507 60.8613Z",
    stroke: stroke,
    strokeDasharray: "2 2"
  }), _ellipse2 || (_ellipse2 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 61,
    cy: 4,
    rx: 3.86401,
    ry: 3.85501,
    fill: "rgb(var(--color-brand-accent))"
  }, /*#__PURE__*/React.createElement("animateMotion", {
    dur: "8s",
    repeatCount: "indefinite",
    path: "M 0 0 L 12.8397 59.998 L -12.8397 59.998 L 0 0"
  }))));
});
export default SvgIconOrb1;
export const raw = __webpack_public_path__ + "static/media/icon-orb-1.219d6707629efd3ba1fba7860baf93e3.svg";